import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';


@Component({
  selector: 'app-modal-info',
  templateUrl: './modal-info.component.html',
  styleUrls: ['./modal-info.component.scss'],
  animations : fuseAnimations,
})
export class ModalInfoComponent implements OnInit {
  todo = [
    {cuponName: 'cupon-AW731'},
    {cuponName: 'cupon-AW732'},
    {cuponName: 'cupon-AW733'},
 ];

 done = [
   {cuponName: 'cupon-AW734'},
   {cuponName: 'cupon-AW735'},
   {cuponName: 'cupon-AW736'},
 ];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalInfoComponent>,
  ) { }

  ngOnInit() {
    console.log(this.data);
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      console.log('cambio posicion');

      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      console.log('translado');
      transferArrayItem(event.previousContainer.data,
                        event.container.data,
                        event.previousIndex,
                        event.currentIndex);
    }
  }
salir(){
  this.dialogRef.close();
}
}
